import React from 'react';
import Aurora from './Aurora';
import './BannedPage.css';

interface BannedPageProps {
  banReason: string;
  banExpiresAt: string;
}

const BannedPage: React.FC<BannedPageProps> = ({ banReason, banExpiresAt }) => {
  const formatTimeRemaining = (expiresAt: string) => {
    const now = new Date();
    const expires = new Date(expiresAt);
    const diff = expires.getTime() - now.getTime();
    
    if (diff <= 0) return 'Expired';
    
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    
    if (days > 0) return `${days} day${days > 1 ? 's' : ''}`;
    return `${hours} hour${hours > 1 ? 's' : ''}`;
  };

  return (
    <div className="banned-page">
      <div className="aurora-background">
        <Aurora
          colorStops={["#7d19ff", "#a560ff", "#801eff"]}
          blend={0.5}
          amplitude={1.0}
          speed={0.5}
        />
      </div>
      <div className="banned-container">
        <div className="logo-section">
          <h1 className="brand-name">SolBlox</h1>
        </div>
        
        <h2 className="banned-title">You are banned for {formatTimeRemaining(banExpiresAt)}</h2>
        
        <p className="banned-reason">
          Reason: {banReason}
        </p>
        
        <a 
          href="https://discord.gg/solblox" 
          target="_blank" 
          rel="noopener noreferrer"
          className="discord-btn"
        >
          Contact Support
        </a>
      </div>
    </div>
  );
};

export default BannedPage;